export default "__VITE_ASSET__BUYS32EX__"